import { api_url } from "../../utils/constants";
const axios = require('axios').default;

// Aggregate per-session rate benchmarks used by the personal trainer rates guide.
// Returns medians and quartiles over a rolling window - aggregates only, never
// per-trainer or per-customer rows. Called from getStaticProps, so callers must
// handle rejection and fall back to the committed snapshot in data/pt-rate-benchmarks.
export const getFitnessRateBenchmarks = (countryName) => {
    return new Promise((resolve, reject) => {

        axios({
          method : "GET",
          url :  api_url + "/public/GetFitnessRateBenchmarks",
          params : {"countryName": countryName},
          headers:  { "Content-Type": "application/json", },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error);
                reject(error);
            }
        )
    });
}

export const downloadFitnessListings = (userId, listingId) => {
    return new Promise((resolve, reject) => {
        
        axios({
          method : "GET",
          url :  api_url + "/profile/DownloadFitnessListings",
          params : {'userId': userId, 'listingId': listingId},
          headers:  { "Content-Type": "application/json", },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const downloadAllFitnessPackages = (typeFilter, country, corporateInd, incrementSize, lowerLimit, orderClause, orderBy) => {
    return new Promise((resolve, reject) => {

        axios({
          method : "GET",
          url :  api_url + "/public/DownloadAllFitnessPackages",
          params : {
            'type': typeFilter,
            'country': country,
            'corporateInd': corporateInd,
            'upperLimit': incrementSize,
            'lowerLimit': lowerLimit,
            'orderClause': orderClause,
            'orderBy': orderBy
          },
          headers:  { "Content-Type": "application/json",},
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const uploadFitnessPackage = (listing) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        let fdd = new FormData();
        fdd.append('listing', listing); 

        axios({
          method : "POST",
          url :  api_url + "/UploadPackage",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const deleteFitnessPackage = (userId, listingId) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        let fdd = new FormData();
        fdd.append('userId', userId); 
        fdd.append('listingId', listingId); 

        axios({
          method : "POST",
          url :  api_url + "/DeletePackage",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const updateFitnessListingActiveInd = (userId, listingId, activeInd) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        let fdd = new FormData();
        fdd.append('userId', userId);
        fdd.append('listingId', listingId);
        fdd.append('activeInd', activeInd);

        axios({
          method : "POST",
          url :  api_url + "/UpdateFitnessListingActiveInd",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const renewFitnessListing = (userId, listingId) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        let fdd = new FormData();
        fdd.append('userId', userId);
        fdd.append('listingId', listingId);

        axios({
          method : "POST",
          url :  api_url + "/RenewListing",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

